module.exports = __webpack_public_path__ + "img/logo_sid.3d38214f.svg";